import { Router } from '@angular/router';
import { catchError, MonoTypeOperatorFunction, Observable, throwError } from 'rxjs';

export function navigateForHttpStatus(router: Router, status: number): void {
  switch (status) {
    case 404:
      router.navigate(['/not-found-error']);
      break;
    case 400:
    case 500:
    case 503:
      router.navigate(['/error']);
      break;
    case 401:
    case 403:
      router.navigate(['/permissions-error']);
      break;
    default:
      router.navigate(['/unexpected-error']);
      break;
  }
}

export function ErrorHandler<T>(router: Router): MonoTypeOperatorFunction<T> {
  return catchError((error): Observable<never> => {
    navigateForHttpStatus(router, error.status);
    return throwError(() => error);
  });
}
